<template>
  <v-dialog :fullscreen="isMobile" width="600" v-model="dialog" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>SỬA THÔNG TIN NGƯỜI DÙNG</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="cancel" class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form class="pt-6" ref="form">
          <v-text-field
            class="required"
            :rules="[$rules.required]"
            v-model="name"
            label="Họ và Tên"
            @input="nameLostFocus()"
            @blur="nameLostFocus()"
            outlined
            dense
          ></v-text-field>
          <div class="mt-n2 mb-2">
            <span class="error--text">*</span> Tài khoản được xử lý theo thông tin tên người dùng dược cung cấp ban đầu.
            Nếu họ tên người dùng bị thay đổi, nội dung tài khoản cũng bị thay đổi theo.
          </div>
          <v-text-field outlined v-model="username" label="Tài khoản" dense disabled></v-text-field>
          <v-select
            :items="filteredRoles"
            label="Vai trò"
            item-value="id"
            item-text="description"
            v-model="role"
            outlined
            dense
            class="required"
            :rules="[$rules.required]"
          ></v-select>
          <v-text-field
            v-model="email"
            label="Email"
            :rules="[$rules.required, $rules.email]"
            class="required"
            outlined
            dense
          ></v-text-field>
          <v-text-field outlined v-model="phone" label="Số điện thoại" dense></v-text-field>

          <v-row v-if="staff" class="mx-2 mb-2">
            <v-col class="d-flex align-center justify-center ml-3" cols="2">
              <UserAvatarPicker :user="staff" type="staff" />
            </v-col>
          </v-row>

          <div v-if="profile.user === staff.user">
            <div class="mb-2">
              <span class="error--text">*</span> Bỏ trống các ô nhập dưới đây nếu không thay đổi mật khẩu
            </div>
            <v-text-field
              v-model="oldPassword"
              label="Mật khẩu cũ"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :rules="isChangePassword ? [$rules.required] : []"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Mật khẩu mới"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :rules="isChangePassword ? [$rules.nospace, $rules.required, $rules.minLength(6)] : []"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="password2"
              label="Nhập lại mật khẩu"
              :append-icon="show2 ? 'visibility' : 'visibility_off'"
              :rules="
                isChangePassword
                  ? [$rules.nospace, $rules.required, $rules.minLength(6), $rules.passInputAgain(password2, password)]
                  : []
              "
              :type="show2 ? 'text' : 'password'"
              @click:append="show2 = !show2"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="px-5">
        <v-btn class="px-4" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="isLoading" depressed class="my-2" color="primary" medium @click="save" :disabled="isLoading">
          <span>Lưu</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import utils from '@/plugins/utils'
import { User } from '../../plugins/api'
import { textHelpers } from '@/helpers/TextHelper.js'
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import mixins from './helper/mixins'

export default {
  components: { UserAvatarPicker },
  data() {
    return {
      dialog: false,
      loading: 0,
      name: '',
      phone: '',
      email: '',
      lastemail: '',
      username: this.username,
      username_indexing: this.username_indexing,
      username_no: this.username_no,
      role: '',
      emailError: '',
      isMobile: false,
      oldPassword: '',
      password: '',
      password2: '',
      show: false,
      show2: false
    }
  },
  props: {
    state: Boolean,
    staff: {}
  },
  computed: {
    ...mapState('role', ['roles']),
    ...mapGetters('auth', ['profile']),

    isLoading() {
      return this.loading > 0
    },
    isChangePassword() {
      return !!this.password
    },
    staffName() {
      return textHelpers.removeSpaces(this.name)
    }
  },

  methods: {
    ...mapActions('user', ['generateUserName', 'changePassword']),
    ...mapActions('staff', ['updateStaff']),
    async save() {
      try {
        this.$loading.active = true
        if (this.$refs.form.validate()) {
          if (this.staff.name !== this.staffName) this.nameLostFocus()

          const users = await User.search({ id_ne: this.staff.user, email: this.email, _limit: 1 })
          if (users.length > 0) {
            this.$alert.error('Email này đã được sử dụng')
            return
          }

          if (this.staff.code !== this.username) {
            // cập nhật tên đăng nhập khi thay đổi tên
            try {
              await User.update(this.staff.user, {
                username: this.username,
                username_indexing: this.username_indexing,
                username_no: this.username_no
              })
            } catch (error) {
              this.$alert.updateError()
              return
            }
          }
          if (this.oldPassword && this.password) {
            const data = {
              userId: this.profile.user,
              oldPassword: this.oldPassword,
              newPassword: this.password
            }
            await this.changePassword(data)
          }

          const data = {
            id: this.staff.id,
            name: this.staffName,
            phone: this.phone,
            code: this.username,
            username_no: this.username_no,
            status: 'active',
            role: this.role,
            email: this.email,
            tags: utils.clearUnicode(this.staffName) + '|' + this.username,
            nameToNumber: utils.generateNameToNumber(utils.generateNameToSort(this.staffName))
          }
          await this.updateStaff(data)
          this.dialog = false
          this.reset()
        }
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },

    async nameLostFocus() {
      if (this.staff.name.toLowerCase() !== this.staffName.toLowerCase()) {
        const {
          username,
          // eslint-disable-next-line
          username_indexing,
          // eslint-disable-next-line
          username_no
        } = await this.generateUserName(this.staffName)
        this.username = username
        // eslint-disable-next-line
        this.username_indexing = username_indexing
        // eslint-disable-next-line
        this.username_no = username_no
      } else {
        this.username = this.staff.code
      }
    },

    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },
    reset() {
      this.name = ''
      this.username = ''
      this.phone = ''
      this.password = ''
      this.email = ''
      this.emailError = ''
    }
  },
  watch: {
    state() {
      this.dialog = true
      if (this.staff.id) {
        this.name = this.staff.name
        this.username = this.staff.code
        this.phone = this.staff.phone
        this.email = this.staff.email
        this.role = this.staff.role
      }
    }
  },
  mixins: [mixins]
}
</script>
